import React from "react";
import {connect} from "react-redux";
import {loadPage} from "../../actions/page";
import {fetchedStandards} from "../../actions/reviewtool";
import Title from "../elements/Title";
import HeroImage from "../elements/HeroImage";
import SideBar from "../elements/standardsOfCare/SideBar";
import SideNav from "../navigation/SideBar";
import Content from "../elements/standardsOfCare/Content";
import TopBar from "../layout/TopBar";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import Loader from "react-loader";


class StandardsPage extends React.Component {
    componentWillUnmount() {
        this.props.loadPage()
    }

    componentDidMount() {
        this.props.fetchedStandards().then();
    }

    state = {
        introductionId: 6,
        sectionId: null,
        clusterId: null,
        standardId: null
    };

    selectPage = (introductionId, sectionId, clusterId, standardId) => {
        this.setState({
            'introductionId': introductionId,
            'sectionId': sectionId,
            'clusterId': clusterId,
            'standardId': standardId
        });
    }

    render() {
        const {modal, navigation, loaded} = this.props;
        return (
          <Loader loaded={loaded}>
          <div className={"transition-item"}>
              <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                  <TopBar/>
                  <TopNavigation/>
                  <SideNav navigation={navigation}/>
                  <HeroImage url={'/assets/general/Placeholder.png'} title={'PLACEHOLDER'}/>
                  <Title introTitle="Standards of Care"/>
                  <div className={"container soc"}>
                      <SideBar selectPage={this.selectPage}/>
                      <Content introductionId={this.state.introductionId}  sectionId={this.state.sectionId} clusterId={this.state.clusterId}
                               standardId={this.state.standardId}/>
                  </div>
                  <Footer/>
              </div>
          </div>
          </Loader>
        )
    };

}


function mapStateToProps(state) {
    return {
        page: state.page,
        modal: state.modal,
        navigation: state.navigation,
        loaded: state.loaded.loaded
    };
}

export default connect(mapStateToProps, {fetchedStandards, loadPage})(StandardsPage);




// WEBPACK FOOTER //
// ./src/components/pages/StandardsPage.js